import { Component, OnInit } from '@angular/core';
import { CmsNavigationComponent, TranslatePipe } from '@spartacus/core';
import { CmsComponentData, NavigationService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-order-tools',
    templateUrl: './kn-br-order-tools.component.html',
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, RouterLink, AsyncPipe, TranslatePipe]
})
export class KnBrOrderToolsComponent implements OnInit {
  componentData$: Observable<CmsNavigationComponent> = this.componentData.data$;
  node$: Observable<any> = this.service.createNavigation(this.componentData.data$);
  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService
  ) {}

  ngOnInit() {}
}
